module.exports = __webpack_public_path__ + "static/media/icon_bathroom.15c92456.svg";